import React from 'react';
import { Grid } from '@hbf/dsl';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { ImageGridCol } from './ImageGridCol';
import { Props } from './types';
import { ImageGridContainer } from './ImageGridContainer';

export const ImageGrid: React.FC<Props> = ({
  tiles,
  onImageClick,
  autoHeight,
  icon,
}) => {
  const { md } = useMediaQuery();
  const [firstTile, ...restTiles] = tiles;
  const hasSecondCol = restTiles.length && md;

  return (
    <ImageGridContainer>
      <Grid item xs={hasSecondCol ? 6 : 12}>
        <ImageGridCol
          tiles={[firstTile]}
          onImageClick={onImageClick}
          hasSecondCol={!!hasSecondCol}
          autoHeight={autoHeight}
          icon={icon}
        />
      </Grid>

      {hasSecondCol ? (
        <Grid item xs={6}>
          <ImageGridCol
            tiles={restTiles}
            onImageClick={onImageClick}
            hasSecondCol={!!hasSecondCol}
          />
        </Grid>
      ) : null}
    </ImageGridContainer>
  );
};
